export default __webpack_public_path__ + "static/events-dark-8c197a8ba9538fcc6706abc4fa09447e.png";